import styled from 'styled-components'

export const Container = styled.thead`
  background-color: ${props => props.theme.colors.background.secondary};
  text-align: left;
  position: sticky;
  top: 0;
  z-index: 1;

  th {
    color: ${props => props.theme.colors.text.subtle};
    text-transform: uppercase;
    padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  }

  th:first-child {
    border-top-left-radius: ${props => props.theme.primitives.radius.radius2};
    border-bottom-left-radius: ${props => props.theme.primitives.radius.radius2};
  }

  th:last-child {
    border-top-right-radius: ${props => props.theme.primitives.radius.radius2};
    border-bottom-right-radius: ${props => props.theme.primitives.radius.radius2};
  }
`

export const THAlignRight = styled.th`
  text-align: right;
`
